<div class="main">
       <app-header [title]="title"></app-header>
        <div class="container-dash">
            <div class="title">
                <p class="wc-cls">Hi User,</p>
                <p class="ass-cls">How would you like to start?</p>
            </div>
            <div class="button-list">
                <div class="chatbot-sec" (click)="chat()">
                    <div class="content">
                        <img class="cnt-icon" src="../../../assets/images/fluent_bot-24-regular.svg"/>
                        <div class="txt-abio">ABIOMED CHATBOT</div>
                    </div>
                    <img class="arrow-icon" src="../../../assets/images/fluent_arrow-up-12-regular.svg" />
                </div>
                <div class="roleplay-sec" (click)="rolePlay()">
                    <div class="content">
                        <img class="cnt-icon" src="../../../assets/images/roleplay-red.svg"/>
                        <div class="txt-abio">ROLEPLAY TRAINER</div>
                    </div>
                    <img class="arrow-icon" src="../../../assets/images/fluent_arrow-up-12-red.svg" />
                </div>
            </div>
            <div class="preference">
                <input type="checkbox" />
                <span>Remember my preference next time</span>
            </div>
        </div>
</div>